module.exports = __webpack_public_path__ + "static/media/Original Korean - Precepts 1989-08-16,23.d0169ec1.txt";